import { QueryClient } from 'react-query'

export const VesselQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: 5000 * 60, // 5 minutes
      //staleTime: 5000 * 60, // 5 minutes //remove stale time for partially reload issue fixes
      retry: false,
    },
  },
})

export const queryCache = VesselQueryClient.getQueryCache()
export const mutationCache = VesselQueryClient.getMutationCache()
